import gql from "graphql-tag"

const UPDATE_ACCESS_CODE = gql`
  mutation UpdateAccessCode(
    $id: bigint!
    $name: String
    $opens_at: timestamp
    $closes_at: timestamp
    $max_orders: Int
    $active: Boolean
    $shipping_method_ids: [Int]
    $products: [AccessCodeProduct]
    $auto_register_orders: Boolean
  ) {
    updateAccessCode(
      id: $id
      name: $name
      closes_at: $closes_at
      opens_at: $opens_at
      max_orders: $max_orders
      active: $active
      shipping_method_ids: $shipping_method_ids
      products: $products
      auto_register_orders: $auto_register_orders
    ) {
      id
    }
  }
`

export default UPDATE_ACCESS_CODE
